import React, { useState } from 'react'
import { useValues } from 'kea'

import TimeZone from './time-zone'
import Availability from './availability'
import ToggleSwitch from './toggle-switch'

import courseLogic from '~/scenes/course/show/logic'

export default function Content () {
  const {
    course: { locationInHouse, locationInStudio, locationWebcam }
  } = useValues(courseLogic)

  const inHouseOnly = !locationWebcam && !locationInStudio && locationInHouse

  const [inStudioOrWebcam, setAtStudioOrWebcam] = useState(locationInStudio || locationWebcam)
  const [atHome, setAtHome] = useState(inHouseOnly)

  const handleClickAtTeacher = () => {
    if (inStudioOrWebcam) {
      setAtHome(true)
    } else {
      setAtHome(false)
    }
    setAtStudioOrWebcam(!inStudioOrWebcam)
  }

  const handleClickAtHome = () => {
    if (atHome) {
      setAtStudioOrWebcam(true)
    } else {
      setAtStudioOrWebcam(false)
    }
    setAtHome(!atHome)
  }

  return (
    <div className='booking-component'>
      <div className='timezone-availability-toggle-container'>
        <TimeZone />
        <ToggleSwitch
          handleClickAtHome={handleClickAtHome}
          handleClickAtTeacher={handleClickAtTeacher}
          atHome={atHome}
          atTeacher={inStudioOrWebcam}
        />
      </div>

      <Availability atHome={atHome} atTeacher={inStudioOrWebcam} />
    </div>
  )
}
